<template lang="">
<div role="banner">
  <nav>
    <v-toolbar
    flat
    color="transparent"
    >

    <v-img
          v-bind:src="companySpecificConfig.logo"
          class="my-3"
          contain
          height="25"
          width="100"
          position="left"
          role="img"
        >
    </v-img>
      <v-toolbar-title class="grey--text justify-bottom pt-1 pr-2">
        <span class="font-weight-medium "
        
        >Quickapply</span>
</v-toolbar-title>
<!--  d-none d-sm-flex -->
<LanguageSwitcher />

    </v-toolbar>
    </nav>
    </div>
</template>
<script>

import LanguageSwitcher from './LanguageSwitcher.vue'



export default {

  computed: {
    companySpecificConfig: {
      get() { return this.$store.state.companySpecificConfig }
      }
  },

  components: {
    LanguageSwitcher
  }

  
}
</script>

<style lang="">
</style>